import * as React from "react"

import { cn } from "@/lib/utils"
import { useTypingAssist } from "@/lib/use-typing-assist"

/** Campos que não são texto livre: sem corretor nem maiúscula automática. */
const NOT_FREE_TEXT_TYPES = new Set(["email", "number", "password", "search", "tel", "url"])
const NOT_FREE_TEXT_MODES = new Set(["numeric", "decimal", "tel", "email", "url", "search"])

type InputProps = React.ComponentProps<"input"> & {
  /** Corretor, maiúscula no começo da frase e acentos óbvios. Padrão: ligado em texto livre. */
  typingAssist?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, typingAssist, ...props }, ref) => {
    const freeText =
      !NOT_FREE_TEXT_TYPES.has(type ?? "text") &&
      !NOT_FREE_TEXT_MODES.has(props.inputMode ?? "text") &&
      !props.readOnly &&
      !/email|tel|name|username|password/.test(props.autoComplete ?? "")
    const assist = useTypingAssist(typingAssist ?? freeText, ref)
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...assist}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
